import React, { useMemo, useState } from "react"
import Web3 from "web3";
import { Fa2Modal, Auth, Forms, Links, notify } from "@housebets/housebets-x-package"
import {CodeInput} from '@housebets/housebets-x-package/lib/components/form/CodeInput';
import { ILinkProps } from "@housebets/housebets-x-package/lib/components/feature/lists/SocialLinks/Button/types";
import {useAppSelector} from "hooks/useAppSelector";
import apiAuth from "app/api/auth";
import { loginSuccess } from "app/store/slices/user";
import { setLoginType } from "app/store/slices/setting";
import { LoginType } from "app/types/common";
import { useWindowSize } from "app/utils/hooks/useWindowSize";
import { useGTMEvents } from "app/hooks/useGTMEvents";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { open2FaModal } from "app/store/slices/user";
import { close2FaModal } from "app/store/slices/user";
import { setData2Fa } from "app/store/slices/user";
import * as Yup from "yup";

let web3: Web3 | undefined; // Will hold the web3 instance

export const AuthLinks: React.FC = () => {
    const {isMobile} = useWindowSize();
    const dispatch = useDispatch();
    const {form, registration} = useGTMEvents();
    const affilkaTag = useAppSelector((state) => state.setting.affilkaTag);
    const promoCode = useAppSelector((state) => state.setting.promoCode);
    const inviteCode = useAppSelector((state) => state.setting.inviteCode);

    const {$t} = useIntl();

    const handleLoginTg = async (data: any) => {
        const res = await apiAuth.tgLogin(data);
        // setIsDisabled(false);
        if (res.data.code === 13) {
            dispatch(open2FaModal());
            return;
        }
        if (res.status === 200 && res.data.code === 0) {
            dispatch(close2FaModal());
            dispatch(loginSuccess(res.data.data));
            dispatch(setLoginType(LoginType.HIDE));
            registration.complete({
                affiliate_code: affilkaTag ? affilkaTag : "-1",
                bonus_code: "",
                currency: res.data.data.userMoneyType,
                marketing_opt_in: false,
                promo_code: promoCode?.toString() || "",
                registration_method: "telegram",
                signup_source: window.location.pathname,
                user_id: res.data.data.userId,
                user_type: "regular",
            });
            return;
        }
        if (res.data.code === 101) {
            notify({
                type: "error",
                title: "SystemError",
            });
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    const handleLoginByMetaMask = async (data: any) => {
        const res = await apiAuth.metaMaskLogin(data);
        // setIsDisabled(false);

        if (res.data.code === 13) {
            dispatch(open2FaModal());
            return;
        }

        if (res.status === 200 && res.data.code === 0) {
            dispatch(loginSuccess(res.data.data));
            dispatch(close2FaModal());
            if (res.data.data.eventType === 0) {
                registration.complete({
                    affiliate_code: affilkaTag ? affilkaTag : "-1",
                    bonus_code: "",
                    currency: res.data.data.userMoneyType,
                    marketing_opt_in: false,
                    promo_code: promoCode?.toString() || "",
                    registration_method: "metamask",
                    signup_source: window.location.pathname,
                    user_id: res.data.data.userId,
                    user_type: "regular",
                });
            } else {
                form.event({
                    event: "form_submit",
                    form_id: "signin_form",
                    form_name: "Sign In Form",
                });
            }
            // showLiveChat();
            dispatch(setLoginType(LoginType.HIDE));
            return;
        }
        if (res.data.code === 101) {
            notify({
                type: "error",
                title: "SystemError",
            });
            return;
        }
        notify({
            type: "error",
            title: $t({id: `Google_LOGIN_ERROR_${res.data.code}`}),
        });
    };

    const links = useMemo<ILinkProps[]>(() => {
        return [
            {
                icon: "GitLabIcon",
                onClick: () => {
                    const login = async () => {
                        try {
                            if (!window.ethereum && !window.web3) {
                                if (!isMobile) {
                                    window.open("https://chromewebstore.google.com/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn");
                                    return;
                                }
                                window.alert("browser have no wallet");
                                return;
                            }
                            if (!web3) {
                                let provider = null;
                                if (window.ethereum) {
                                    provider = window.ethereum;
                                } else if (window.web3) {
                                    provider = window.web3.currentProvider;
                                }
                                await provider.enable();
                                web3 = new Web3(provider);
                            }
                            const accounts = await web3.eth.getAccounts();
                            if (!accounts) {
                                window.alert("Please activate MetaMask first.");
                                return;
                            }
                            const publicAddress = accounts[0]?.toLowerCase();
                            const message = $t(
                                {id: "loginAdress"},
                                {
                                    publicAddress: publicAddress,
                                    time: Math.floor(Math.random() * 900000) + 100000,
                                },
                            );

                            const signature = await web3.eth.personal.sign(
                                message,
                                publicAddress,
                                "", // MetaMask will ignore the password argument here
                            );

                            const data = {
                                publicAddress,
                                signature,
                                affilkaTag,
                                signData: btoa(encodeURIComponent(message)),
                                ...(promoCode ? {promoCode: promoCode.toString()} : {inviteCode: inviteCode.toString() || "-1"}),
                            };

                            dispatch(
                                setData2Fa({
                                    type: "metaMaskLogin",
                                    data: data,
                                }),
                            );

                            handleLoginByMetaMask(data);
                        } catch (error) {
                            console.log("error=", error);
                        }
                    };
                    registration.intent();
                    login();
                },
            },
            {
                icon: "GoogleAuthIcon",
                onClick: () => {
                    if (window.handleGoogleLogin) {
                        registration.intent();
                        window.handleGoogleLogin();
                    }
                },
            },
            {
                icon: "TelegramIcon",
                onClick: () => {
                    const login = () => {
                        window.Telegram?.Login.auth({bot_id: "6561810283", request_access: "write", embed: 1}, async (data: any) => {
                            if (data) {
                                const dataTgLogin = {
                                    ...(promoCode ? {promoCode: promoCode.toString()} : {inviteCode: inviteCode.toString() || "-1"}),
                                    ...{affilkaTag: affilkaTag},
                                    ...data,
                                };
                                // setDataSumbitAuth(dataTgLogin);
                                // setOnSumbitAuth("tgLogin");

                                dispatch(
                                    setData2Fa({
                                        type: "tgLogin",
                                        data: dataTgLogin,
                                    }),
                                );

                                handleLoginTg(dataTgLogin);
                            }
                        });
                    };
                    registration.intent();
                    login();
                },
            },
        ];
    }, [isMobile]);

    return (
        <>
            <Links links={links} v2 paddingTop />
        </>
    );
};

AuthLinks.displayName = "AuthLinks";
